<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">
        이문화<br />
        <span class="container_content_list_title_span"
          >대면 / 비대면(실시간 화상)</span
        >
      </div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication20.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#이문화 적응</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              이문화 이해 및 비즈니스 프로토콜 (특강/워크숍)
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            파견 국가와 현지 조직에 대한 이문화 및 다양성 이해를 통해 당면할
            문제를 사전 대비하여 성공적인 업무 적응을 지원합니다.
          </div>
          <div class="container_content_text_content">
            가속화되는 글로벌화 속에서 다양한 문화적 환경에서 성공적인
            상호작용을 위해 필요로 하는 역량 개발 목적<br />
            이문화 자가진단을 통한 본인의 강/약점을 파악 및 이문화 적응성 향상,
            이문화 이해 및 프로토콜, 매너 습득<br />
            글로벌 비즈니스 전문가 육성을 위한 단계별 국가별 맞춤 실무 워크숍 및
            멘토링 프로그램 진행
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication21.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#국가별 심화</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              파견국가문화 심화사례 (특강/워크숍)
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            해외 주재원, 지역전문가 및 글로벌 업무자 대상으로 다양성과 이문화
            이해를 높여 효과적인 역할 수행을 하도록 돕습니다.
          </div>
          <div class="container_content_text_content">
            주재원 및 장, 단기 해외출장 등 이미 파견할 국가가 정해진 경우, 파견
            전 깊이 있는 이문화와 도시 문화-생활 정보 선행 학습 목적<br />
            현지 국가에 대한 객관적인 정보, 문화적인 차이, 파견 전 사전 준비
            사항, 발생 가능한 이슈 사항 해결 방안에 대한 종합적인 학습<br />
            사전 서베이를 통한 맞춤 Q&A 진행 및 특정 국가 현지인들의 가치관,
            관습 등을 생생한 사례 중심으로 이해하는 코칭형 학습 진행
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication22.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#마이크로러닝</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              국가별 이문화 이해 마이크로러닝
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            성공적인 현지 정착을 위한 이문화 이해, 글로벌 커뮤니케이션, 현지
            업무 수행을 위한 포괄적 교육을 제공합니다.
          </div>
          <div class="container_content_text_content">
            글로벌 커뮤니케이션과 다양한 문화 이해 역량을 편리하고 유용한 시간에
            학습하는 콘텐츠 제공<br />
            미국, 베트남, 사우디아라비아, 아랍에미리트, 이라크, 인도, 헝가리 등
            33개 국가 이문화 콘텐츠 제공<br />
            각 국가별 최신 이문화 마이크로러닝을 통해 이문화 적응성 향상 및
            Global Standard 이해 가능
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: { Contact },
  name: "Crossculture",
};
</script>

<style></style>
